import isEmpty from "lodash/isEmpty";
import { ReactNode } from "react";
import { SummaryInfo } from "./ListBaseApiResponseModel";

export class BaseApiResponseModel<T extends Object> {
  passedDelete: any;
  constructor(
    public code?: number,
    public data?: T,
    public message?: string,
    public extras?: {
      extras?: Error;
    },
    public pagination?: Paging,
    public summary?: SummaryInfo,
    public isSuccess?: boolean,
  ) {}
}

export class SingleBaseResponseModel<T extends Object> {
  data: {
    data?: T;
    error?: Error;
    message?: string;
    code?: number;
  };
}

export class RevenueInfo {
  USD?: number;
  VND?: number;

  constructor(data?: Partial<RevenueInfo>) {
    this.USD = data?.USD;
    this.VND = data?.VND;
  }
}

export class Paging {
  limit?: number;
  page?: number;
  total?: number;
  success?: number;
  error?: number;
  other?: number;
  revenue?: RevenueInfo;
  deposit?: RevenueInfo;
  withdrawal?: RevenueInfo;
  debit?: RevenueInfo;
  refund?: RevenueInfo;
}

export class Error {
  status?: number;
  statusText?: string;
  code?: number | string;
  message?: string;
  extras?: {
    extras?: Error;
  };

  mapErrorRes?(error: Error) {
    if (!!error?.extras?.extras && !isEmpty(error?.extras?.extras)) {
      let extrasMess = error?.extras?.extras;
      return {
        status: error?.status,
        code: extrasMess?.code,
        message: extrasMess?.message || error?.statusText,
      };
    } else {
      return {
        status: error?.status,
        code: error?.code,
        message: error?.message || error?.statusText,
      };
    }
  }
}

export class Report {
  day?: number;
  week?: number;
  month?: number;
  lastMonth?: number;
}

export class Result {
  type: "success" | "error";
  message: string;
}

export class SelectList {
  label?: string;
  value?: any;
  color?: string;
  code?: string;
  userStoreId?: string;
  type?: number;
  providerCode?: string;
  isStore?: boolean;
  icon?: ReactNode;
}

export default {
  BaseApiResponseModel,
  Error,
};
